import staffFetch from "./staffFetch";
import React, { useEffect, useState } from "react";

const API = "https://live-evo.com/api";

function StaffUserReportsPage() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadReports = async () => {
    try {
      const res = await staffFetch(`${API}/staff/user-reports`);
      const data = await res.json();

      setReports(data.reports || []);
    } catch (err) {
      console.log("Erreur loadReports:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadReports();
  }, []);

  const warnUser = async (id) => {
    try {
      await staffFetch(`${API}/staff/user-reports/${id}/warn`, {
        method: "PUT"
      });

      alert("Utilisateur averti");

      loadReports();
    } catch {
      alert("Impossible d'avertir");
    }
  };

  const restrictUser = async (id) => {
    try {
      await staffFetch(`${API}/staff/user-reports/${id}/restrict-mp-24h`, {
        method: "PUT"
      });

      alert("MP bloqués 24h");

      loadReports();
    } catch {
      alert("Impossible de restreindre");
    }
  };

  const closeReport = async (id) => {
    const ok = window.confirm(
      "Classer ce signalement sans suite ?"
    );

    if (!ok) return;

    try {
      await staffFetch(`${API}/staff/user-reports/${id}/close`, {
        method: "PUT"
      });

      alert("Signalement fermé");

      loadReports();
    } catch {
      alert("Impossible de fermer");
    }
  };

  const getProofUrl = (proofUrl) => {
    if (!proofUrl) return null;

    if (proofUrl.startsWith("http")) {
      return proofUrl;
    }

    return `https://live-evo.com${proofUrl}`;
  };

  if (loading) {
    return (
      <div style={center}>
        Chargement...
      </div>
    );
  }

  return (
    <div style={container}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <button
          style={backBtn}
          onClick={() => {
            window.location.href = "/staff";
          }}
        >
          ← Retour staff
        </button>

        {reports.length === 0 ? (
          <div style={empty}>
            Aucun signalement utilisateur
          </div>
        ) : (
          reports.map((item) => {
            const proofImage = getProofUrl(item.proof_url);

            return (
              <div
                key={item.id}
                style={card}
              >
                <div style={title}>
                  🚨 Signalement utilisateur #{item.id}
                </div>

                <div style={label}>
                  Utilisateur signalé :
                </div>

                <div style={value}>
                  {item.reported_pseudo || "Pseudo inconnu"}
                  {" "}
                  (
                  {item.reported_email}
                  )
                </div>

                <div style={label}>
                  Signalé par :
                </div>

                <div style={value}>
                  {item.reporter_pseudo || "Pseudo inconnu"}
                  {" "}
                  (
                  {item.reporter_email}
                  )
                </div>

                <div style={label}>
                  Raison :
                </div>

                <div style={value}>
                  {item.reason}
                </div>

                {item.description && (
                  <>
                    <div style={label}>
                      Description :
                    </div>

                    <div style={value}>
                      {item.description}
                    </div>
                  </>
                )}

                {proofImage && (
                  <>
                    <div style={label}>
                      Preuve :
                    </div>

                    <img
                      src={proofImage}
                      alt=""
                      style={image}
                    />
                  </>
                )}

                <div style={buttons}>
                  <button
                    style={btnWarn}
                    onClick={() => warnUser(item.id)}
                  >
                    Avertir
                  </button>

                  <button
                    style={btnRestrict}
                    onClick={() => restrictUser(item.id)}
                  >
                    Bloquer MP 24h
                  </button>

                  <button
                    style={btnClose}
                    onClick={() => closeReport(item.id)}
                  >
                    Fermer
                  </button>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}

const container = {
  minHeight: "100vh",
  background: "#05070d",
  padding: 14,
  color: "#fff"
};

const backBtn = {
  background: "#020b14",
  border: "1px solid #00f2ff",
  padding: 10,
  borderRadius: 10,
  marginBottom: 10,
  color: "#00f2ff",
  fontWeight: "bold",
  width: "100%",
  cursor: "pointer"
};

const card = {
  background: "#0d111a",
  padding: 15,
  borderRadius: 10,
  marginBottom: 12,
  border: "1px solid #00f2ff"
};

const title = {
  color: "#00f2ff",
  fontWeight: "bold",
  marginBottom: 8
};

const label = {
  color: "#8fa6ad",
  marginTop: 5
};

const value = {
  color: "#fff"
};

const image = {
  width: "100%",
  maxHeight: "500px",
  objectFit: "cover",
  borderRadius: 10,
  marginTop: 8
};

const buttons = {
  display: "flex",
  gap: 8,
  flexWrap: "wrap",
  marginTop: 14
};

const btnWarn = {
  background: "#ffaa00",
  padding: 10,
  borderRadius: 8,
  border: "none",
  color: "#000",
  fontWeight: "bold",
  cursor: "pointer"
};

const btnRestrict = {
  background: "#ff2d55",
  padding: 10,
  borderRadius: 8,
  border: "none",
  color: "#fff",
  fontWeight: "bold",
  cursor: "pointer"
};

const btnClose = {
  background: "#00f2ff",
  padding: 10,
  borderRadius: 8,
  border: "none",
  color: "#000",
  fontWeight: "bold",
  cursor: "pointer"
};

const empty = {
  color: "#8fa6ad",
  textAlign: "center",
  marginTop: 30
};

const center = {
  minHeight: "100vh",
  background: "#05070d",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: "#00f2ff"
};

export default StaffUserReportsPage;
